import React, { useRef, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useIsMobile } from "@/hooks/use-mobile";
interface FundraisingSectionProps {
  onOpenForm: () => void;
}
const FundraisingSection = ({
  onOpenForm
}: FundraisingSectionProps) => {
  const isMobile = useIsMobile();
  const videoRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // Charger l'API IFrame YouTube
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
    }

    // Initialiser le lecteur YouTube une fois que l'API est chargée
    const loadVideo = () => {
      if (videoRef.current && window.YT) {
        new window.YT.Player(videoRef.current, {
          videoId: 'Sljv1J8vU28',
          playerVars: {
            autoplay: 0,
            controls: 1,
            modestbranding: 1,
            rel: 0,
            showinfo: 0,
            mute: 0,
            origin: window.location.origin
          },
          events: {
            onError: (event: any) => {
              console.error('Erreur du lecteur YouTube:', event);
            }
          }
        });
      }
    };
    if (window.YT && window.YT.Player) {
      loadVideo();
    } else {
      // Si l'API n'est pas encore chargée, configurer un rappel
      window.onYouTubeIframeAPIReady = loadVideo;
    }
    return () => {
      // Nettoyage
      window.onYouTubeIframeAPIReady = null;
    };
  }, []);
  return <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-normal mb-6">Naboo lève 70M$ en Série B</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">Notre ambition : construire la plateforme mondiale d'événementiel B2B pilotée par l’IA</p>
        </div>

        <div className={`w-full mx-auto mb-12 overflow-hidden rounded-xl shadow-xl ${isMobile ? 'max-w-full' : 'max-w-4xl h-auto'}`}>
          <AspectRatio ratio={16 / 9}>
            <div ref={videoRef} id="youtube-player" className="w-full h-full" />
          </AspectRatio>
        </div>

        <div className="flex justify-center">
          <Button className="bg-cta-green text-cta-green-foreground text-sm px-6 py-2 font-semibold rounded-md shadow-lg hover:bg-cta-green/90 hover:shadow-xl hover:shadow-cta-green/30 hover:scale-105 transition-all duration-300" onClick={onOpenForm}>
            Commencer gratuitement
          </Button>
        </div>
      </div>
    </section>;
};
export default FundraisingSection;